
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();
  
  const services = [
    {
      icon: 'ri-secure-payment-line',
      title: t('services.digitalPayments.title'),
      description: t('services.digitalPayments.description'),
      features: t('services.digitalPayments.features', { returnObjects: true }) as string[]
    },
    {
      icon: 'ri-bank-line',
      title: t('services.bankingSoftware.title'),
      description: t('services.bankingSoftware.description'),
      features: t('services.bankingSoftware.features', { returnObjects: true }) as string[]
    },
    {
      icon: 'ri-code-line',
      title: t('services.customDevelopment.title'),
      description: t('services.customDevelopment.description'),
      features: t('services.customDevelopment.features', { returnObjects: true }) as string[]
    },
    {
      icon: 'ri-funds-line',
      title: t('services.strategicInvestment.title'),
      description: t('services.strategicInvestment.description'),
      features: t('services.strategicInvestment.features', { returnObjects: true }) as string[]
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('services.cyclosSupport.title'),
      description: t('services.cyclosSupport.description'),
      features: t('services.cyclosSupport.features', { returnObjects: true }) as string[]
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-[#9F7B5B] rounded-lg flex items-center justify-center mr-4">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <div className="grid grid-cols-2 gap-3">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-[#9F7B5B] mr-2"></i>
                    <span className="text-sm text-gray-600">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
